import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, CircularProgress } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EditIcon from "@mui/icons-material/Edit";
import { tokens } from "../../../theme";
import { useTheme } from "@mui/material";
import { green } from "@mui/material/colors";
import { useTranslation } from "react-i18next";

const InvoiceDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const apiUrl = "https://oven-backend.onrender.com";


  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const response = await axios.get(`${apiUrl}/sales/${id}`);
        setInvoice(response.data);
      } catch (error) {
        console.error("Error fetching invoice:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInvoice();
  }, [id]);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box m="20px" sx={{ direction: isRTL ? "rtl" : "ltr" }}>
      <Typography variant="h4" fontWeight="bold">
        {t("invoice_details")} 🧾
      </Typography>

      <Box mt={2} p={2} component={Paper} elevation={3}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}>
        <Typography>{t("customer")}: {invoice.employee_id?.name || t("not_available")}</Typography>
        <Typography>{t("date")}: {new Date(invoice.date).toLocaleDateString()}</Typography>
        <Typography>{t("payment_status")}: {t(invoice.payment_status)}</Typography>
        <Typography>{t("inventory_status")}: {t(invoice.inventory_status)}</Typography>
      </Box>

      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: colors.blueAccent[700] }}>
              <TableCell><b>{t("product")}</b></TableCell>
              <TableCell><b>{t("quantity")}</b></TableCell>
              <TableCell><b>{t("price")}</b></TableCell>
              <TableCell><b>{t("subtotal")}</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoice.products.map((product, index) => (
              <TableRow key={index}>
                <TableCell>{product.name_sales}</TableCell>
                <TableCell>{product.quantity}</TableCell>
                <TableCell>${product.price}</TableCell>
                <TableCell>${product.quantity * product.price}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box mt={2} p={2} component={Paper} elevation={3} color={green}>
        <Typography variant="h6">
          {t("total_amount")}: <b>${invoice.total_amount}</b>
        </Typography>
      </Box>

      <Box mt={3} display="flex" gap={2}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<EditIcon />}
          sx={{ display: "flex", alignItems: "center", gap: "8px" }}
          onClick={() => navigate(`/UpdateInvoices/${id}`)}
        >
          {t("edit_invoice")}
        </Button>

        <Button variant="contained"  
                 sx={{ display: "flex", alignItems: "center", gap: "8px" }}
 color="secondary" startIcon={<PrintIcon />} onClick={() => window.print()}>
          {t("print_invoice")}
        </Button>

        <Button variant="contained"
                  sx={{ display: "flex", alignItems: "center", gap: "8px" }}
                  color="success" startIcon={<PictureAsPdfIcon />}>
          {t("download_pdf")}
        </Button>
      </Box>
    </Box>
  );
};

export default InvoiceDetails;
